import React, {useEffect, useState} from "react"
import {RegisterSubmitEvent} from "../../Containers/RootContainer";
import {CallbackArray} from "../../Utils/types";
import ReservationActions from "../../Redux/reservationRedux";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../Redux";
import VehicleFound from "./VehicleFound";
import {CircularProgress, Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import BackButton from "./Common/BackButton";
import {useTranslation} from "react-i18next";
import VehicleNotices from "./VehicleNotices";

interface VehicleInformationProps {
    registrationNumber: string;
    autoContinue?: boolean;
    handleContinue: () => void;
    hasOtherReservation: boolean
    onBack: () => void;
}

const VehicleInformation = ({registrationNumber, autoContinue, handleContinue, hasOtherReservation, onBack}: VehicleInformationProps) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const [restrictionsHandled, setRestrictionsHandled] = useState(false)

    const registerInfo = useSelector((state: RootState) => state.reservation?.registerInfo)
    const fetching = useSelector((state: RootState) => state.reservation?.fetching.registerInfo)
    const stationId = useSelector((state: RootState) => state.ui?.settings.station.id)

    useEffect(() => {
        const handleSubmitRegisterPlate = (
            { registerNumber, vehicleType, searchType, vehicleClass, vehicleGroup, fuel }: RegisterSubmitEvent,
            callback?: () => void | CallbackArray,
        ) => {
            const callbacks = callback && Array.isArray(callback) ? callback : (callback ? [callback] : undefined)

            dispatch(
                ReservationActions.getRegisterInfo(
                    registerNumber?.toUpperCase()?.trim() ?? '',
                    vehicleType,
                    vehicleClass,
                    vehicleGroup,
                    fuel,
                    searchType,
                    stationId,
                    callbacks,
                ),
            )
        }

        setRestrictionsHandled(false)

        handleSubmitRegisterPlate({
            registerNumber: registrationNumber,
            vehicleType: null,
            searchType: null,
            vehicleClass: null,
            vehicleGroup: null,
            fuel: null
        } as RegisterSubmitEvent, undefined)
    }, [registrationNumber, dispatch, stationId])

    useEffect(() => {
        if (fetching === false && registerInfo && restrictionsHandled === true && autoContinue) {
            setTimeout(() => handleContinue(), 0)
        }
    }, [fetching, registerInfo, restrictionsHandled, autoContinue, handleContinue]);

    const handleRestrictions = () => {
        setRestrictionsHandled(true)
    }

    if (fetching === false && registerInfo) {
        if (restrictionsHandled === false) {
            return (<VehicleNotices
                checkTrafficMass={!autoContinue}
                checkAdditionalGroups={!autoContinue}
                registerInfo={registerInfo}
                handleContinue={handleRestrictions}
            />)
        } else if (autoContinue) {
            return null
        }
        return (<VehicleFound
            registerInfo={registerInfo}
            handleContinue={handleContinue}
            hasOtherReservation={hasOtherReservation}
            onBack={onBack}
        />)
    }

    return (
        <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={4} className={'pageMainContainer'}>
            <Grid>
            </Grid>
            {fetching && <Grid style={{textAlign: 'center'}}>
                <Typography variant="h3" gutterBottom>
                    {t('selfService.fetchingVehicleInformation')}
                </Typography>
                <CircularProgress size={48} color="primary" />
            </Grid>}
            {fetching === false && registerInfo === null && <>
                <Grid style={{textAlign: 'center'}}>
                    <Typography variant="h3" gutterBottom>
                        {t('selfService.vehicleInformationNotFound')}
                    </Typography>
                </Grid>
                <Grid style={{textAlign: 'center'}}>
                    <Typography variant="h1" noWrap className="registrationNumber">{registrationNumber}</Typography>
                    <Typography variant="subtitle1">
                        {t('selfService.vehicleInformationNotFoundInfo')}
                    </Typography>
                </Grid>
                <Grid style={{textAlign: 'center'}}>
                </Grid>
                <Grid style={{textAlign: 'center'}}>
                </Grid>
            </>}
            <Grid className="footerButtons">
                <Grid container wrap="nowrap" spacing={4} justifyContent="space-between" alignItems="end">
                    <Grid>
                        <BackButton onBack={onBack} />
                    </Grid>
                </Grid>
            </Grid>
    </Grid>)
}

export default VehicleInformation
